<template>
  <div class="custom-modal" v-if="showModal">
    <el-dialog
      :class="{'modal-content-no-padding': modalContentNoPadding}"
      :visible.sync="showModal"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template #header>
        <slot name="header"></slot>
      </template>
      <slot></slot>
      <template #footer>
        <slot name="footer">
          <el-button
            v-if="showCancelBtn"
            :type="cancelBtnType"
            @click.native="cancelHandle($event)"
          >
            {{ cancelBtnText }}
          </el-button>
          <el-button
            v-if="showSubmitBtn"
            :type="submitBtnType"
            @click.native="submitHandle($event)"
          >
            {{ submitBtnText }}
          </el-button>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    showSubmitBtn: {
      type: Boolean,
      default: true
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    submitBtnText: {
      type: String,
      default: '确认'
    },
    cancelBtnType: {
      type: String,
      default: 'default'
    },
    submitBtnType: {
      type: String,
      default: 'primary'
    },
    modalContentNoPadding: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    showModal: {
      get(){
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    submitHandle(event) {
      this.$emit('submitHandle', event)
    },
    cancelHandle(event) {
      this.$emit('cancelHandle', event)
    }
  }
}
</script>

<style lang="less" scoped>
.modal-content-no-padding /deep/ .el-dialog__body {
  padding: 0;
}
</style>
